import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import Loader from '../../Components/Utility/Loader/Loader';
import { archivedDam, deleteDamFilesByIdAction, fetchDamAcrhivedFiles, filterSortData } from './store/DAM.action';
import DamListCard from '../../Components/Card/DamListCard/DamListCard';
import { useDAMModuleState } from './Provider';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';

function AcrhivedFiles({ isSelectAll }) {
  const history = useHistory();
  const { t } = useTranslation('common');
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const { Damstate, setDAMState, damAddEditAccess, damDeleteAccess } = useDAMModuleState([]);
  const { selectedIdArray } = Damstate;
  const location = useLocation();
  const [state, setState] = useState({
    damList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isArchivedModal: false,
    activeList: 'open',
    folderList: [],
    selectedFolders: [],
    archivedList: [],
    binList: [],
    dragging: false,
    archivedComment: '',
  });

  const dispatch = useDispatch();
  const {
    damModule: {
      filterValues: { pageIndex, pageSize, searchText },
      totalAcrhivedCount,
      damArhivedlist,
    },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (totalAcrhivedCount > damArhivedlist.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damArhivedlist, totalAcrhivedCount]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalAcrhivedCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterSortData(obj));
    await dispatch(fetchDamAcrhivedFiles(params));
  };

  useEffect(() => {
    if (Array.isArray(damArhivedlist)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        archivedList: damArhivedlist,
      }));
      setDAMState((prev) => ({ ...prev, archivedList: damArhivedlist }));
    }
  }, [damArhivedlist]);

  useEffect(() => {
    const callFn = async () => {
      setState((prev) => ({ ...prev, loading: true }));

      const localstorageFilter = JSON.parse(localStorage.getItem('damListFilter'));
      const params = {
        pageIndex,
        pageSize,
        searchText,
        loading: localstorageFilter?.loading,
        colourTheme: localstorageFilter?.colourTheme,
        primaryColour: localstorageFilter?.primaryColour,
        secondaryColour: localstorageFilter?.secondaryColour,
        folder: localstorageFilter?.folder,
        fileType: localstorageFilter?.fileType,
        assetType: localstorageFilter?.assetType,
        productType: localstorageFilter?.productType,
        brand: localstorageFilter?.brand,
        gradingGroups: localstorageFilter?.gradingGroups,
        category1: localstorageFilter?.category1,
        category2: localstorageFilter?.category2,
        category3: localstorageFilter?.category3,
        category4: localstorageFilter?.category4,
        dynamicDropdown: localstorageFilter?.dynamicDropdown,
      };

      await dispatch(fetchDamAcrhivedFiles(params));
      setState((prev) => ({ ...prev, loading: false }));
    };
    callFn();
  }, [dispatch]);

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setDAMState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    } else {
      setDAMState((prev) => ({ ...prev, selectedIdArray: [...selectedItems, id] }));
    }
  };

  useEffect(() => {
    if (state?.archivedList?.length > 0 && isSelectAll) {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of state.archivedList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setDAMState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
  }, [state?.archivedList, isSelectAll]);

  const deleteDamFolderGroup = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damId = [selectedBomLibraryGroupId];
    } else {
      params.damId = [...selectedIdArray];
    }
    const res = await dispatch(deleteDamFilesByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));

    setBomId(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      damList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };
    await dispatch(fetchDamAcrhivedFiles(params));
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const handleArchive = (item) => {
    setBomId(item);
    setState((prev) => ({
      ...prev,
      isArchivedModal: !state?.isArchivedModal,
    }));
  };

  const handleArchivedConfirmed = async () => {
    const obj = {
      archieveComment: state?.archivedComment,
      isArchived: location?.state?.activeList === 'open',
    };

    if (selectedBomLibraryGroupId) {
      obj.damIds = [selectedBomLibraryGroupId];
    } else {
      obj.damIds = [...selectedIdArray];
    }

    const res = await dispatch(archivedDam(obj, t));
    if (res === 200) {
      closeAcrhiveTrashDeleteModal();
      refreshPage();
      setState((prevData) => ({
        ...prevData,
        archivedComment: '',
        // activeList: "open",
      }));
      history.push('/digital-assets-management', { activeList: 'archived' });
      setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    }
  };

  const closeAcrhiveTrashDeleteModal = () => {
    setState((prevData) => ({
      ...prevData,
      isArchivedModal: false,
    }));
  };

  return (
    <div>
      <InfiniteScroll dataLength={state?.archivedList?.length} next={handlePageNextInScroll} hasMore={state?.hasMore}>
        <div className="container-fluid my-3">
          <Row>
            {state?.archivedList?.map((item, i) => (
              <DamListCard
                key={item?._id}
                item={item}
                index={i}
                onCheck={onSelectCheckBox}
                selectedIds={selectedIdArray}
                onDelete={deleteDamFolderGroup}
                handleArchive={handleArchive}
                damAddEditAccess={damAddEditAccess}
                damDeleteAccess={damDeleteAccess}
              />
            ))}
          </Row>

          {state?.archivedList?.length === 0 && !state.loading && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
          {state?.loading && <Loader />}
        </div>
      </InfiniteScroll>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE')}
          title="Delete"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
      {state?.isArchivedModal && (
        <ConfirmationPopup
          onOpen={state?.isArchivedModal}
          fromSupplier
          onConfirm={() => handleArchivedConfirmed()}
          title={location?.state?.activeList === 'open' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_DAM') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE_DAM')}
          message={`${t('DAM_MAIN_VIEW.LISTING_VIEW.ARE_YOU_SURE_YOU_WANT_TO')} ${
            location?.state?.activeList === 'open' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVE') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE')
          } ${t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAM')}`}
          toggle={closeAcrhiveTrashDeleteModal}
          isCommentOn
          comment={state?.archivedComment}
          commentText={(e) =>
            setState((prevState) => ({
              ...prevState,
              archivedComment: e.target.value,
            }))
          }
        />
      )}
    </div>
  );
}

export default AcrhivedFiles;
